'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.selectors = exports.constants = exports.sagas = exports.reducers = undefined;

var _sagas = require('./sagas');

var _sagas2 = _interopRequireDefault(_sagas);

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _actions = require('./actions');

var actions = _interopRequireWildcard(_actions);

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

var _selectors = require('./selectors');

var selectors = _interopRequireWildcard(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = exports.reducers = {
    translation: _reducer2.default
};
var sagas = exports.sagas = [_sagas2.default];

exports.constants = constants;
exports.selectors = selectors;
exports.actions = actions;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/translation-tokens/dist/main/index.js
// module id = 271
// module chunks = 0